"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _hooks = require("@alycecom/hooks");

var _providers = require("../../../../providers");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _ScheduleModal = _interopRequireDefault(require("./ScheduleModal/ScheduleModal"));

var _PresetScheduleForm = _interopRequireDefault(require("./PresetScheduleForm/PresetScheduleForm"));

var _CustomScheduleForm = _interopRequireDefault(require("./CustomScheduleForm/CustomScheduleForm"));

var SendBatchButton = function SendBatchButton(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      isSendingFulfilled = _ref.isSendingFulfilled,
      sendBatchById = _ref.sendBatchById,
      scheduleBatchById = _ref.scheduleBatchById;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId,
      onBatchSent = _useGiftingFlowContex.onBatchSent;

  var buttonGroupRef = (0, _react.useRef)(null);
  var menuButtonRef = (0, _react.useRef)(null);

  var _useModalState = (0, _hooks.useModalState)(),
      isOpen = _useModalState.isOpen,
      handleToggle = _useModalState.handleToggle,
      handleClose = _useModalState.handleClose;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isCustomFormVisible = _useState2[0],
      setIsCustomFormVisible = _useState2[1];

  var trackGiftingFlowPreviewStepSendGiftButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowPreviewStepSendGiftButtonClicked)();
  var trackGiftingFlowPreviewStepScheduleGiftButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowPreviewStepScheduleGiftButtonClicked)();
  var handleSendBatch = (0, _react.useCallback)(function () {
    if (batchId) {
      sendBatchById();
      trackGiftingFlowPreviewStepSendGiftButtonClicked();
    }
  }, [batchId, sendBatchById, trackGiftingFlowPreviewStepSendGiftButtonClicked]);
  var handleSchedule = (0, _react.useCallback)(function (scheduleAt) {
    if (batchId) {
      scheduleBatchById(scheduleAt);
      trackGiftingFlowPreviewStepScheduleGiftButtonClicked(scheduleAt);
    }
  }, [batchId, scheduleBatchById, trackGiftingFlowPreviewStepScheduleGiftButtonClicked]);
  (0, _react.useEffect)(function () {
    if (isSendingFulfilled) {
      onBatchSent();
    }
  }, [onBatchSent, isSendingFulfilled]);
  var handleCloseModal = (0, _react.useCallback)(function (event) {
    var _menuButtonRef$curren;

    if (event && (buttonGroupRef.current && buttonGroupRef.current.contains(event.target) || (_menuButtonRef$curren = menuButtonRef.current) !== null && _menuButtonRef$curren !== void 0 && _menuButtonRef$curren.contains(event.target) || event.target === document.body)) {
      return;
    }

    setIsCustomFormVisible(false);
    handleClose();
  }, [handleClose]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    ref: buttonGroupRef,
    variant: "contained",
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: ['fab', 'telegram-plane'],
      color: "inherit"
    }),
    onClick: handleSendBatch
  }, "Send Gifts"), /*#__PURE__*/_react.default.createElement(_ui.Button, {
    ref: menuButtonRef,
    variant: "contained",
    color: "primary",
    onClick: handleToggle
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: isOpen ? 'chevron-up' : 'chevron-down'
  }))), /*#__PURE__*/_react.default.createElement(_ScheduleModal.default, {
    open: isOpen,
    onClose: handleCloseModal,
    anchorEl: menuButtonRef.current
  }, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !isCustomFormVisible,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_PresetScheduleForm.default, {
    onSelectPreset: handleSchedule,
    onSelectCustom: function onSelectCustom() {
      return setIsCustomFormVisible(true);
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: isCustomFormVisible,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_CustomScheduleForm.default, {
    onSubmit: handleSchedule,
    onCancel: handleCloseModal
  }))));
};

var _default = SendBatchButton;
exports.default = _default;